import { useEffect, useState } from "react";
import { signIn, useSession } from "next-auth/react";
import { useRouter } from "next/router";
import MainTemplate from "src/components/agility-pageTemplates/MainTemplate";
import LeftSidebar from "./LeftSidebar";

const AdherencePage = ({ header, pageProps }) => {
  const router = useRouter();
  const queryParams = router.query;
  const { data: session, status } = useSession();
  const [isAttempting, setIsAttempting] = useState(false);

  useEffect(() => {
    if (status === "unauthenticated" && queryParams.silent === "true") {
      triggerAuth0SilentLogin();
    }
  }, [status, queryParams]);
  

  const triggerAuth0SilentLogin = async () => {
    // Attempt Auth0 Silent Login
    setIsAttempting(true);
    const callbackUrl = `${window.location.origin}${window.location.pathname}`;
    const result = await signIn("auth0", { prompt: "none", callbackUrl });
    if (!result?.ok) {
      // fallback to normal login page
      signIn("auth0", { callbackUrl });
    }else{
      setIsAttempting(false);
    }
  };

  if (status === "loading") return <p className="tw-container">Loading...</p>;

  return (
    <div className="tw-flex-grow tw-relative">
      <main id="adherence-main" className="lg:tw-ml-60">
        {!session ? (
          <div className="tw-container adherence-rt max-lg:tw-pt-8 xl:!tw-pl-16">
            {!!isAttempting ? (
              <>
                <h1>Attempting Automatic Sign-In</h1>
                <p className="tw-text-xl tw-mb-4">Please wait while we securely authenticate your session...</p>
              </>
            ) : (
              <>
                <h1>Welcome to MESCA Adherence</h1>
                <p className="tw-text-xl tw-mb-4">Please sign in to continue</p>
                <button
                  onClick={() => signIn("auth0")}
                  className="tw-bg-black tw-text-white tw-py-2 tw-px-6"
                >
                  Sign In
                </button>
              </>
            )}
          </div>
        ) : (
          <>
            <LeftSidebar pageProps={pageProps}/>
            <MainTemplate {...pageProps} />
          </>
        )}
      </main>
    </div>
  );
};

export default AdherencePage;
